import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './auth.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordRecoverComponent } from './forgot-password/forgot-password-recover/forgot-password-recover.component';
import { ForgotPasswordNewPasswordComponent } from './forgot-password/forgot-password-new-password/forgot-password-new-password.component';
import { GuidGuard } from '../guards/guid.guard';
import { ResetExpiredPasswordComponent } from './reset-expired-password/reset-expired-password.component';
import { ExpiredPasswordMessageComponent } from './reset-expired-password/expired-password-message/expired-password-message.component';
import { ExternalLoginComponent } from './external-login/external-login.component';


const routes: Routes = [
  {
    path: "",
    component: AuthComponent,
    children: [
      {
        path: "login/external/:guid",
        component: ExternalLoginComponent
      },
      {
        path: "login",
        component: LoginComponent
      },
      {
        path: "recover",
        component: ForgotPasswordRecoverComponent
      },
      {
        path: "new-password/:guid",
        component: ForgotPasswordNewPasswordComponent,
        canActivate: [GuidGuard]
      },
      {
        path: "reset-expired-password",
        component: ResetExpiredPasswordComponent
      },
      {
        path:'expired-password-message/:isInternal',
        component: ExpiredPasswordMessageComponent
      },
      {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full'
      }
    ]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
